import AccountService from '../entities/account-service';
import AchievementService from '../entities/achievement-service';
import AddOnService from '../entities/add-on-service';
import AffiliationService from '../entities/affiliation-service';
import AnalyticsService from '../entities/analytics-service';
import ApplicationConfigService from '../entities/application-config-service';
import AssetsService from '../entities/assets-service';
import { AuthenticationService } from '../entities/authentication-service';
import CartService from '../entities/cart-service';
import ChartLayoutService from '../entities/chart-layout-service';
import CommunityStatsService from '../entities/community-stats-service';
import ContestAccountService from '../entities/contest-account-service';
import ContestService from '../entities/contest-service';
import ContractService from '../entities/contract-service';
import CouponService from '../entities/coupon-service';
import CreditsService from '../entities/credits-service';
import FuturesSymbolsService from '../entities/futures-symbols-service';
import GroupService from '../entities/group-service';
import MailOtpService from '../entities/mail-otp-service';
import PartnerService from '../entities/partner-service';
import PaymentSessionService from '../entities/payment-session-service';
import PayoutService from '../entities/payout-service';
import PositionService from '../entities/position-service';
import ProductService from '../entities/product-service';
import ProgramService from '../entities/program-service';
import PurchaseService from '../entities/purchase-service';
import QuickPurchaseService from '../entities/quick-purchase-service';
import ReleaseService from '../entities/release-service';
import TradeService from '../entities/trade-service';
import TradeTalkService from '../entities/trade-talk-service';
import UserActivityService from '../entities/user-activity-service';
import UserService from '../entities/user-service';
import UsersService from '../entities/users-service';
import WatchlistService from '../entities/watchlist-service';
import HttpService from './http-service';

interface ApiItem {
  variableName: string;
  // eslint-disable-next-line
  classEntity: any;
  route: string;
}

const ApiList: ApiItem[] = [
  {
    variableName: 'usersService',
    classEntity: UsersService,
    route: UsersService.route,
  },
  {
    variableName: 'couponService',
    classEntity: CouponService,
    route: CouponService.route,
  },
  {
    variableName: 'contractService',
    classEntity: ContractService,
    route: ContractService.route,
  },
  {
    variableName: 'creditsService',
    classEntity: CreditsService,
    route: CreditsService.route,
  },
  {
    variableName: 'userActivityService',
    classEntity: UserActivityService,
    route: UserActivityService.route,
  },
  {
    variableName: 'payoutService',
    classEntity: PayoutService,
    route: PayoutService.route,
  },
  {
    variableName: 'cartService',
    classEntity: CartService,
    route: CartService.route,
  },
  {
    variableName: 'purchaseService',
    classEntity: PurchaseService,
    route: PurchaseService.route,
  },
  {
    variableName: 'authenticationService',
    classEntity: AuthenticationService,
    route: AuthenticationService.route,
  },
  {
    variableName: 'assetsService',
    classEntity: AssetsService,
    route: AssetsService.route,
  },
  {
    variableName: 'userService',
    classEntity: UserService,
    route: UserService.route,
  },
  {
    variableName: 'accountService',
    classEntity: AccountService,
    route: AccountService.route,
  },
  {
    variableName: 'tradeService',
    classEntity: TradeService,
    route: TradeService.route,
  },
  {
    variableName: 'programService',
    classEntity: ProgramService,
    route: ProgramService.route,
  },
  {
    variableName: 'productService',
    classEntity: ProductService,
    route: ProductService.route,
  },
  {
    variableName: 'groupService',
    classEntity: GroupService,
    route: GroupService.route,
  },
  {
    variableName: 'addOnService',
    classEntity: AddOnService,
    route: AddOnService.route,
  },
  {
    variableName: 'partnerService',
    classEntity: PartnerService,
    route: PartnerService.route,
  },
  {
    variableName: 'positionService',
    classEntity: PositionService,
    route: PositionService.route,
  },
  {
    variableName: 'applicationConfigService',
    classEntity: ApplicationConfigService,
    route: ApplicationConfigService.route,
  },
  {
    variableName: 'achievementService',
    classEntity: AchievementService,
    route: AchievementService.route,
  },
  {
    variableName: 'affiliationService',
    classEntity: AffiliationService,
    route: AffiliationService.route,
  },
  {
    variableName: 'analyticsService',
    classEntity: AnalyticsService,
    route: AnalyticsService.route,
  },
  {
    variableName: 'contestService',
    classEntity: ContestService,
    route: ContestService.route,
  },
  {
    variableName: 'contestAccountService',
    classEntity: ContestAccountService,
    route: ContestAccountService.route,
  },
  {
    variableName: 'tradeTalkService',
    classEntity: TradeTalkService,
    route: TradeTalkService.route,
  },
  {
    variableName: 'chartLayoutService',
    classEntity: ChartLayoutService,
    route: ChartLayoutService.route,
  },
  {
    variableName: 'mailOtpService',
    classEntity: MailOtpService,
    route: MailOtpService.route,
  },
  {
    variableName: 'paymentSessionService',
    classEntity: PaymentSessionService,
    route: PaymentSessionService.route,
  },
  {
    variableName: 'watchlistService',
    classEntity: WatchlistService,
    route: WatchlistService.route,
  },
  {
    variableName: 'futuresSymbolsService',
    classEntity: FuturesSymbolsService,
    route: FuturesSymbolsService.route,
  },
  {
    variableName: 'communityStatsService',
    classEntity: CommunityStatsService,
    route: CommunityStatsService.route,
  },
  {
    variableName: 'releaseService',
    classEntity: ReleaseService,
    route: ReleaseService.route,
  },
  {
    variableName: 'quickPurchaseService',
    classEntity: QuickPurchaseService,
    route: QuickPurchaseService.route,
  },
];

export interface ApiFactoryParams {
  httpService: HttpService;
}

class ApiFactory {
  private httpService: HttpService;

  usersService: UsersService = {} as UsersService;
  userService: UserService = {} as UserService;
  couponService: CouponService = {} as CouponService;
  contractService: ContractService = {} as ContractService;
  creditsService: CreditsService = {} as CreditsService;
  userActivityService: UserActivityService = {} as UserActivityService;
  authenticationService: AuthenticationService = {} as AuthenticationService;
  analyticsService: AnalyticsService = {} as AnalyticsService;
  payoutService: PayoutService = {} as PayoutService;
  cartService: CartService = {} as CartService;
  purchaseService: PurchaseService = {} as PurchaseService;
  accountService: AccountService = {} as AccountService;
  tradeService: TradeService = {} as TradeService;
  programService: ProgramService = {} as ProgramService;
  productService: ProductService = {} as ProductService;
  groupService: GroupService = {} as ProgramService;
  addOnService: AddOnService = {} as AddOnService;
  partnerService: PartnerService = {} as PartnerService;
  positionService: PositionService = {} as PositionService;
  applicationConfigService: ApplicationConfigService =
    {} as ApplicationConfigService;
  achievementService: AchievementService = {} as AchievementService;
  assetsService: AssetsService = {} as AssetsService;
  affiliationService: AffiliationService = {} as AffiliationService;
  contestService: ContestService = {} as ContestService;
  contestAccountService: ContestAccountService = {} as ContestAccountService;
  tradeTalkService: TradeTalkService = {} as TradeTalkService;
  chartLayoutService: ChartLayoutService = {} as ChartLayoutService;
  mailOtpService: MailOtpService = {} as MailOtpService;
  paymentSessionService: PaymentSessionService = {} as PaymentSessionService;
  watchlistService: WatchlistService = {} as WatchlistService;
  futuresSymbolsService: FuturesSymbolsService = {} as FuturesSymbolsService;
  communityStatsService: CommunityStatsService = {} as CommunityStatsService;
  releaseService: ReleaseService = {} as ReleaseService;
  quickPurchaseService: QuickPurchaseService = {} as QuickPurchaseService;

  constructor({ httpService }: ApiFactoryParams) {
    this.httpService = httpService;

    ApiList.forEach((api: ApiItem) => {
      this[api.variableName as keyof ApiFactory] = new api.classEntity({
        httpService,
        route: api.route,
      });
    });
  }

  public setHttpServiceActions(
    logout: () => Promise<void>,
    refreshToken: () => Promise<void>,
    adminToken?: string,
  ) {
    this.httpService.setActions(logout, refreshToken, adminToken);
  }

  public clearAdminToken() {
    this.httpService.clearAdminToken();
  }

  public setAuthorizationHeader(token: string) {
    this.httpService.setAuthorizationHeader(token);
  }
}

export default ApiFactory;
